import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MEMBERSHIP_REQUIRED_EVENT } from '../api/client';
import { Button, ResponsiveDialog } from '../components/ui';
import { useT } from '../i18n';

type RequiredTier = 'plus' | 'ultra';

export function MembershipRequiredHost() {
  const navigate = useNavigate();
  const { t } = useT();
  const [tier, setTier] = useState<RequiredTier | null>(null);

  useEffect(() => {
    const onRequired = (event: Event) => {
      const detail = (event as CustomEvent<{ tier?: unknown }>).detail;
      setTier(detail?.tier === 'ultra' ? 'ultra' : 'plus');
    };
    window.addEventListener(MEMBERSHIP_REQUIRED_EVENT, onRequired);
    return () => window.removeEventListener(MEMBERSHIP_REQUIRED_EVENT, onRequired);
  }, []);

  const close = () => setTier(null);
  const openPaywall = () => {
    const requiredTier = tier ?? 'plus';
    close();
    navigate(`/mitgliedschaft?tier=${requiredTier}`);
  };

  return (
    <ResponsiveDialog
      open={tier !== null}
      onClose={close}
      title={t('membership.settings_title')}
      footer={<Button leadingIcon="lock" onClick={openPaywall}>{t('membership.view_plans')}</Button>}
    >
      <p>{t('membership.free_description')}</p>
    </ResponsiveDialog>
  );
}
